define.alias("checkout/components/interval", "calendar/components/interval");